// extracted by mini-css-extract-plugin
export default {"icon":"SocialsIcon_icon__0-vEd"};